import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { GeneralIcons } from '@bluebeam/react-skyline-art';
import { Button } from '@bluebeam/react-skyline-button';
const ProgressStepperItem = ({ children, className, isComplete, name, onClick, ...rest }) => {
    const dataAttributes = useDataAttributes(rest);
    return (_jsxs("li", { className: buildClassName('flex flex-row items-center gap-2 p-0', className), ...dataAttributes, children: [_jsx(GeneralIcons.StepIndicator, { size: "24px", isComplete: isComplete }), onClick && (_jsx(Button, { "aria-label": name, className: buildClassName('p-0 text-base', {
                    'text-darker-gray hover:cursor-default hover:no-underline': !isComplete,
                }), onClick: (e) => {
                    e.stopPropagation();
                    onClick();
                }, variant: "text", children: children ? children : name })), !onClick && (_jsx("span", { "aria-label": name, className: buildClassName('skyline-text-button-2 inline-flex min-h-[32px] items-center p-0 text-base', {
                    'text-darker-gray hover:cursor-default hover:no-underline': !isComplete,
                }, { 'text-primary-blue': isComplete }), children: children ? children : name }))] }));
};
export default ProgressStepperItem;
//# sourceMappingURL=ProgressStepperItem.js.map